import type { ErrorCopy } from '@shared/errors/catalog';

/**
 * The `error_code` values these two surfaces meet, from `backend-content`'s own
 * §11 catalog.
 *
 * **Never inline a backend code in JSX.** The code is a log key; what reaches
 * the operator is the sentence, and the `X-Request-ID` is what they quote.
 *
 * The sharpest entry is the body refusal. The service checks the body **on
 * write** against a closed allow-list and names each violation in `details[]`,
 * and the console does not second-guess it: a second sanitiser on this side that
 * disagreed with the server's would be worse than none. What the copy has to do
 * is tell an operator what to change, and the only thing they can change from
 * this surface is the text they typed.
 */
export const pagesErrors: Readonly<Record<string, ErrorCopy>> = {
  CONTENT_UNSAFE_PAGE_BODY: {
    message: 'النصّ يحمل ما لا تقبله الصفحة العامّة. راجع ما لُصق فيه من مصدر آخر ثمّ أعد الحفظ.',
    tone: 'warning',
  },
  CONTENT_NOT_FOUND: {
    message: 'لم نعثر على هذه الصفحة. أعد تحميل الشاشة، وإن تكرّر فأبلغ الدعم.',
    tone: 'warning',
  },
  CONTENT_FORBIDDEN: {
    message: 'تحرير الصفحات التعريفية خارج صلاحيّتك.',
    tone: 'warning',
  },
  CONTENT_CONFLICT: {
    message: 'حُرّرت الصفحة من جلسة أخرى بينما كانت مفتوحة. أعد التحميل ثمّ أعد كتابتك.',
    tone: 'warning',
  },
  CONTENT_UPSTREAM_TIMEOUT: {
    message: 'تأخّرت الخدمة عن الردّ. أعد تحميل الصفحة للاطّلاع على ما حُفظ.',
    tone: 'neutral',
  },
};
